import React from 'react'
import {cn} from '@containers/html-utils'
import CheckedIcon from './checked.svg'
import IndeterminateIcon from './indeterminate.svg'
import UncheckedIcon from './unchecked.svg'

export interface Props {
  value: boolean | undefined
  className?: string
  onChange?: (value: boolean) => void
  stopPropagation?: boolean
}

export const TriCheckbox = (props: Props) => {
  const Icon =
    props.value === undefined
      ? IndeterminateIcon
      : props.value === true
        ? CheckedIcon
        : UncheckedIcon
  return (
    <div
      className={cn('inline-flex h-16 w-16 cursor-pointer', props.className)}
      onClick={e => {
        props.onChange?.(!props.value)
        if (props.stopPropagation) {
          e.stopPropagation()
        }
      }}
    >
      <Icon className="m-auto" />
    </div>
  )
}
